import { render, staticRenderFns } from "./LWtb.vue?vue&type=template&id=61a568b9&scoped=true&"
import script from "./LWtb.vue?vue&type=script&lang=js&"
export * from "./LWtb.vue?vue&type=script&lang=js&"
import style0 from "./LWtb.vue?vue&type=style&index=0&id=61a568b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a568b9",
  null
  
)

export default component.exports